import { GoogleOAuthProvider } from '@react-oauth/google';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { RecoilRoot } from 'recoil';
import App from './App';
import ErrorFallback from './components/ErrorFallback';
import { getGoogleClientId } from './config/googleClient';
import { AuthProvider } from './contexts/Auth';
import ThemeContextProvider from './contexts/ThemeContext';
import { TitleProvider } from './contexts/TitleContext';
import { ChatPrefsProvider } from './design/ChatPrefsContext';
import { AppearanceProvider } from './design/AppearanceContext';
import { DesignProvider } from './design/DesignContext';
import reportWebVitals from './reportWebVitals';
import './design/design.css';
import './theme/index.css';

// Login 3D models are optional; do not let a stale SW cache poison missing GCS assets.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

const googleClientId = getGoogleClientId();
const IdentityProvider = ({ children }) =>
  process.env.REACT_APP_SUITE_SSO === 'true' ? (
    children
  ) : (
    <GoogleOAuthProvider clientId={googleClientId}>
      {children}
    </GoogleOAuthProvider>
  );

const tree = (
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.href = '/';
      }}
    >
      <RecoilRoot>
        {/* Ambient palette engine above auth/theme so login shares the sky. */}
        <DesignProvider>
          <ThemeContextProvider>
            {/* ID-token Sign-In only; no extra OAuth scopes on the provider. */}
            <IdentityProvider>
              <AuthProvider>
                <AppearanceProvider>
                  <SnackbarProvider>
                    <ChatPrefsProvider>
                      <TitleProvider>
                        <App />
                      </TitleProvider>
                    </ChatPrefsProvider>
                  </SnackbarProvider>
                </AppearanceProvider>
              </AuthProvider>
            </IdentityProvider>
          </ThemeContextProvider>
        </DesignProvider>
      </RecoilRoot>
    </ErrorBoundary>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(tree);

reportWebVitals();
